const RefreshButton = ({onClick, className, ...rest}) => {

return (
    <div className={`
      w-[6.8125rem] h-[6.8125rem] bg-[#172952] rounded-xl
      flex
      justify-center
      items-center
      click-effect ${className}`}
      onClick={onClick}
      {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 24 24"
        className="w-[5.5rem] h-[5.5rem]"
    >
        <g>
            <path d="M19.9 11c-.6 0-1 .4-1 1 0 3.9-3.1 7-7 7h-.7c-.2 0-.3 0-.5-.1-.2 0-.3-.1-.5-.1-.1 0-.2-.1-.3-.1-.7-.2-1.4-.6-2-1-.1-.1-.2-.1-.2-.2-.1-.1-.2-.2-.3-.2-.2-.1-.4-.3-.5-.4l-.2-.2 1.8-.3c.5-.1.9-.6.8-1.2-.1-.5-.6-.9-1.2-.8l-3.3.6-.8.2c-.3 0-.5.2-.6.4s-.2.5-.2.7l.8 4.2c.1.5.5.8 1 .8h.2c.5-.1.9-.6.8-1.2l-.3-1.7c.2.2.5.4.7.6h.1c.1.1.2.2.3.2.2.2.4.3.7.4.2.4.5.5.8.7h.1c.1.1.3.1.5.2.4.1.8.2 1.1.3.2 0 .4.1.6.1h1.2c5 0 9-4 9-9 .1-.5-.4-.9-.9-.9M4 13c.6 0 1-.4 1-1 0-3.9 3.1-7 7-7h.7c.2 0 .3 0 .5.1.2 0 .3.1.5.1.1 0 .2.1.3.1.7.2 1.4.5 2 1 .1.1.2.1.3.2s.2.1.3.2.2.3.4.4l.2.2-1.8.3c-.5.1-.9.6-.8 1.2.1.5.5.8 1 .8h.2l4.2-.8c.5-.1.9-.6.8-1.2L20 3.5c-.1-.5-.6-.9-1.2-.8-.5.1-.9.6-.8 1.2l.3 1.7c-.2-.2-.5-.5-.7-.6h-.1c-.1-.1-.2-.2-.3-.2-.2-.2-.4-.3-.7-.5s-.6-.3-.9-.5h-.1c-.1-.1-.3-.1-.5-.2-.4-.1-.8-.2-1.1-.3-.2 0-.4-.1-.6-.1h-1.2c-5 0-9 4-9 9-.1.4.3.8.9.8" fill="#e2e2e2"></path>
        </g>
    </svg>
    </div>
)};
export default RefreshButton;